let csrfToken;

export class ApiError extends Error {
  constructor(code, details, status) { super(code); this.code = code; this.details = details; this.status = status; }
}

export async function requestApi(path, options = {}) {
  const method = options.method ?? 'GET';
  const headers = { Accept: 'application/json' };
  if (options.body !== undefined) headers['Content-Type'] = 'application/json';
  if (method !== 'GET') headers['X-CSRF-Token'] = csrfToken;
  let response;
  try { response = await fetch(`/api${path}`, { method, headers, credentials: 'same-origin', keepalive: options.keepalive ?? false, body: options.body === undefined ? undefined : JSON.stringify(options.body) }); }
  catch { throw new ApiError('network_error'); }
  const result = await response.json();
  if (!response.ok) throw new ApiError(result.error?.code ?? 'internal_error', result.error?.details, response.status);
  if (result.csrfToken) csrfToken = result.csrfToken;
  return result;
}

export const initializeSession = () => requestApi('/session');
